module.exports = {
  'tpl-form.tpl-form-field-type-text': require('./fields/textField'),
  'tpl-form.tpl-form-field-type-select': require('./fields/selectField'),
  'tpl-form.tpl-form-field-type-date-time': require('./fields/dateTimeField'),
  'tpl-form.tpl-form-field-type-checkbox': require('./fields/checkboxField'),
};
